// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Input, OnInit } from '@angular/core';
import { ISubscription } from '../../../../types/subscription';
import { Observable } from 'rxjs';
import { IManageUser, UserRole } from '../../../../types/user';
import { selectUser } from '../../../store/user/user.selectors';
import { IIncludedSoftware } from '../products.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app.state';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-agent-sub',
    templateUrl: './agent-sub.component.html',
    styleUrls: ['./agent-sub.component.scss', '../products.component.scss'],
    standalone: false
})
export class AgentSubComponent implements OnInit {
  @Input() subscription: ISubscription;
  @Input() title: string;
  columnsToDisplay = ['productName', 'assignedLicenses', 'purchasedQuantity'];
  user$: Observable<IManageUser> = this.store.select(selectUser());
  data: IIncludedSoftware[] = [];
  protected readonly UserRole = UserRole;

    constructor(private readonly store: Store<AppState>) {
    }

  ngOnInit() {
      this.data = [
        {
          productName: "Management Agent",
          assignedLicenses: this.subscription?.used ?? 0,
          licensesApply: true,
          canAssign: false,
          hasEndpoints: true,
          purchasedQuantity: this.subscription?.count ?? 0,
          hiddenForPartners: [],
        }
      ];
  }
}
